var _defs, _path, _path2, _line, _line2, _rect, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f3f16f20-9011-4b26-b22f-9639b74d84df",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a60df7af-8272-4a58-a610-1bffd1174b71,.becca75e-bec2-4cb6-93d5-a325f217dc72{fill:none;}.a9aa69aa-f08e-4c0e-af95-c0a5080ed8f0,.becca75e-bec2-4cb6-93d5-a325f217dc72{stroke:#8e8e8e;}.a60df7af-8272-4a58-a610-1bffd1174b71,.a9aa69aa-f08e-4c0e-af95-c0a5080ed8f0,.becca75e-bec2-4cb6-93d5-a325f217dc72{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.a9aa69aa-f08e-4c0e-af95-c0a5080ed8f0,.fe91e0ba-8f2e-46fd-86c7-a8662faea678{fill:#228ad2;}.a60df7af-8272-4a58-a610-1bffd1174b71{stroke:#645346;}.ab06327b-aa49-4440-aac8-ffc00a9a4699{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "doc") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "becca75e-bec2-4cb6-93d5-a325f217dc72",
    d: "M22.3,78.2a4.1,4.1,0,0,0,4.1,4.2H67.3a4.2,4.2,0,0,0,4.2-4.2V21.8a4.2,4.2,0,0,0-4.2-4.2H36.7L22.3,32.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a9aa69aa-f08e-4c0e-af95-c0a5080ed8f0",
    d: "M22.3,32.1H32.6A4.1,4.1,0,0,0,36.7,28V17.6Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a60df7af-8272-4a58-a610-1bffd1174b71",
    x1: 61,
    y1: 41.1,
    x2: 32.8,
    y2: 41.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a60df7af-8272-4a58-a610-1bffd1174b71",
    x1: 61,
    y1: 50.9,
    x2: 32.8,
    y2: 50.9
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fe91e0ba-8f2e-46fd-86c7-a8662faea678",
    x: 32.8,
    y: 59.5,
    width: 44.9,
    height: 14.99,
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ab06327b-aa49-4440-aac8-ffc00a9a4699",
    d: "M41.4,62.4a12.3,12.3,0,0,1,2.8-.2,5.9,5.9,0,0,1,4.1,1.2A4.6,4.6,0,0,1,49.7,67a5.4,5.4,0,0,1-1.5,4,6.3,6.3,0,0,1-4.4,1.4H41.4Zm1.3,8.9H44c2.8,0,4.3-1.6,4.3-4.3s-1.3-3.9-4.1-3.9H42.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ab06327b-aa49-4440-aac8-ffc00a9a4699",
    d: "M60,67.2c0,3.4-2.1,5.3-4.7,5.3s-4.5-2.1-4.5-5.1,2-5.3,4.7-5.3S60,64.2,60,67.2Zm-7.8.1c0,2.2,1.2,4.1,3.2,4.1s3.2-1.9,3.2-4.2-1-4.1-3.2-4.1S52.2,65.1,52.2,67.3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "ab06327b-aa49-4440-aac8-ffc00a9a4699",
    d: "M68.8,72a7.6,7.6,0,0,1-2.7.5,4.7,4.7,0,0,1-5-5.1,5,5,0,0,1,5.3-5.3,5.4,5.4,0,0,1,2.4.4l-.3,1.1a4.1,4.1,0,0,0-2.1-.4c-2.3,0-3.9,1.5-3.9,4.1s1.4,4.1,3.9,4.1a6,6,0,0,0,2.1-.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.48ab6c7ec1196ff93cb8adf4d68dd71b.svg";
export { ForwardRef as ReactComponent };